enum ECodeErrorsResponse {
  INVALID_CODE_RESPONSE_MESSAGE = 'Invalid code.',
  TIMED_OUT_CODE_RESPONSE_MESSAGE = 'Code has expired.',
}

export enum ECodeType {
  SMS = 'SMS',
  EMAIL = 'Email',
}

export const getCodeError = (type: ECodeType, text?: string) => {
  if (!text) return;

  switch (text) {
    case ECodeErrorsResponse.INVALID_CODE_RESPONSE_MESSAGE:
      return `Wrong ${type} code. Please try again.`;
    case ECodeErrorsResponse.TIMED_OUT_CODE_RESPONSE_MESSAGE:
      return `This ${type} code is expired.`;
    default:
      return text;
  }
};

export const dollars = (value: number, wholeDollars = false) => {
  if (!value) return 0;

  if (wholeDollars) {
    return Math.round(value / 100);
  }
  return Math.round(value) / 100;
};

export const toCurrency = (value: number, smart = true) => {
  let decimal = 2;
  if (value % 1 === 0 && smart) {
    decimal = 0;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  });

  return formatter.format(value);
};
